import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Parient } from "../../types/formRVEO";

/**
 * Hook para manejar la gestión de beneficiarios
 */
export const useBeneficiaries = (
  relationshipData: any[],
  setValueBeneficiarie: any,
  assuredSex: string
) => {
  const [parients, setParients] = useState<any>([]);
  const [selectedParient, setSelectedParient] = useState<Parient | null>();
  const [showModalAddBeneficiarie, setShowModalAddBeneficiarie] = useState<boolean>(false);

  const methodsBeneficiarie = useForm({
    mode: "onChange",
  });

  const {
    handleSubmit: handleSubmitBeneficiarie,
    register: registerBeneficiarie,
    errors: errorsBeneficiarie,
    reset: resetBeneficiaries,
    watch: watchBeneficiarie,
    setValue: setValueBeneficiarieLocal,
  } = methodsBeneficiarie;

  const relationshipBeneficiarie = watchBeneficiarie("relationship");
  const bornDateBeneficiarie = watchBeneficiarie("bornDate");
  const saludBeneficiarie = watchBeneficiarie("sano");
  const genrerBenefiarie = watchBeneficiarie("genrerBenefiarie");

  const deleteParient = (parientP: any) => {
    const indexParient = parients.findIndex(
      (parient: any) => parientP.id === parient.id
    );
    const newParients = [
      ...parients.slice(0, indexParient),
      ...parients.slice(indexParient + 1),
    ];
    setParients(newParients);
  };

  const handleOpenModalAddBeneficiaries = () => {
    setSelectedParient(null);
    setShowModalAddBeneficiarie(true);
  };

  const handleCloseModalBeneficiarie = () => {
    setShowModalAddBeneficiarie(false);
    setSelectedParient(null);
    resetBeneficiaries();
  };

  const handleOpenModalEditBeneficiarie = (parient: any) => {
    setShowModalAddBeneficiarie(true);
    setSelectedParient(parient);
  };

  const handleAddBeneficiarie = (parient: any) => {
    if (selectedParient) {
      const editParients = parients.map((item: any) => {
        return item.id === selectedParient.id ? { ...parient } : { ...item };
      });
      setParients(editParients);
    } else {
      setParients([
        ...parients,
        {
          id: parients.length + 1,
          ...parient,
        },
      ]);
    }
    resetBeneficiaries();
    setSelectedParient(null);
    setShowModalAddBeneficiarie(false);
  };

  // Función para filtrar relationship data
  const getFilteredRelationshipData = () => {
    const hasConyugue = parients.some((p: any) => p.relationship === "C");
    const hasConcubino = parients.some((p: any) => p.relationship === "T");
    
    if (selectedParient) {
      return relationshipData;
    }
    
    if (hasConyugue || hasConcubino) {
      return relationshipData.filter((r: any) => r.value !== "C" && r.value !== "T");
    }
    
    return relationshipData;
  };

  // useEffect para establecer género en beneficiarios según parentesco
  useEffect(() => {
    if (relationshipBeneficiarie === "C" || relationshipBeneficiarie === "T") {
      const oppositeSex = assuredSex === "M" ? "F" : "M";
      setValueBeneficiarieLocal("genrerBenefiarie", oppositeSex);
      if (setValueBeneficiarie) {
        setValueBeneficiarie("genrerBenefiarie", oppositeSex);
      }
    }
  }, [relationshipBeneficiarie, assuredSex]);

  return {
    parients,
    setParients,
    selectedParient,
    showModalAddBeneficiarie,
    setShowModalAddBeneficiarie,
    deleteParient,
    handleOpenModalAddBeneficiaries,
    handleCloseModalBeneficiarie,
    handleOpenModalEditBeneficiarie,
    handleAddBeneficiarie,
    handleSubmitBeneficiarie,
    registerBeneficiarie,
    errorsBeneficiarie,
    methodsBeneficiarie,
    relationshipBeneficiarie,
    bornDateBeneficiarie,
    saludBeneficiarie,
    genrerBenefiarie,
    setValueBeneficiarieLocal,
    resetBeneficiaries,
    getFilteredRelationshipData,
  };
};
